import {
  PRIMARY_INDUSTRIES,
  SECONDARY_INDUSTRIES,
  TERTIARY_INDUSTRIES,
} from '@/constants/industries';
import { toSignificant } from '@/utilities/formatting';
import {
  parseRules,
  updateMarketRule,
  updateIndustryRule,
  getIndustryIdFromSlug,
} from '@/pages/Screener/functions';

const defaultRules = JSON.stringify([
  ['order_by', 'market_cap', 'desc'],
  ['value_score', '>=', 0],
  ['dividends_score', '>=', 0],
  ['future_performance_score', '>=', 0],
  ['health_score', '>=', 0],
  ['past_performance_score', '>=', 0],
  ['grid_visible_flag', '=', true],
  ['market_cap', 'is_not_null'],
  ['primary_flag', '=', true],
  ['is_fund', '=', false],
]);

/**
 * Convert given rules values from float (0 - 1) to percent (0 - 100)
 * @param rules: List of rules
 */

export function rulesWithPercent(
  rules: (number | string)[]
): (number | string)[] {
  /**
   * TARGET_RULES: List of rules requiring min & max values convertion
   * from (0 - 1 or 2) to percent ( 0% - 100% or 200%)
   */
  const TARGET_RULES = [
    'insider_buying',
    'debt_equity',
    'net_debt_to_equity',
    'health_current_solvency_ratio',
    'past_net_income_margin',
    'past_ebitda_margin',
  ];

  const safeRules = rules[0] === 'aor' ? rules[1][0] : rules; // Assuming the first entry of an AOR is the most important
  if (
    safeRules.some((rule) => TARGET_RULES.includes(rule as string)) &&
    safeRules.length >= 4
  ) {
    const rulesTwo = safeRules[2];
    const rulesThree = safeRules[3];
    const firstVal =
      rulesTwo <= 2 && typeof rulesTwo === 'number' //some rules range (0 - 200)
        ? parseFloat(toSignificant(rulesTwo * 100, 2))
        : rulesTwo;
    const secondVal =
      rulesThree <= 2 && typeof rulesThree === 'number'
        ? parseFloat(toSignificant(rulesThree * 100, 2))
        : rulesThree;
    return [...safeRules.slice(0, 2), firstVal, secondVal];
  }
  return rules;
}

export const updateRule =
  (rules: string | undefined | null) =>
  (market?: string, industry?: string | number) => {
    const rulesString = rules ? rules : defaultRules;
    /** we will append/update the market + industry */
    let parsedRules = parseRules(rulesString);
    if (
      market !== 'global' &&
      market !== 'any' &&
      typeof market !== 'undefined'
    ) {
      parsedRules = updateMarketRule([market], [], parsedRules).filter(
        ([rule]) => rule !== 'exchange_symbol'
      );
    }
    if (
      typeof industry !== 'undefined' &&
      industry !== '' &&
      industry !== 'any'
    ) {
      let industryId = industry.toString();
      if (typeof industry === 'string') {
        industryId = getIndustryIdFromSlug(industry);
      }
      // Identify industry level and provide the correct order
      const primary = PRIMARY_INDUSTRIES[industryId] ? [industryId] : [];
      const secondary = SECONDARY_INDUSTRIES[industryId] ? [industryId] : [];
      const tertiary = TERTIARY_INDUSTRIES[industryId] ? [industryId] : [];
      parsedRules = updateIndustryRule(
        primary,
        secondary,
        tertiary,
        parsedRules
      );
    }
    return JSON.stringify(parsedRules);
  };
